<div *ngIf="congratulationType$ | async as congratulationType">
  <div class="container">
    <ng-container *ngIf="userInfo$ | async as userInfo">
      <div class="col-12 col-md-12">
        <h1 i18n>Congratulations on your decision to join us!</h1>
      </div>
    </ng-container>

    <ng-container [ngSwitch]="congratulationType">
      <ng-container *ngSwitchCase="CongratulationTypes.Normal">
        <div class="col-12 col-md-12">
          <h2 i18n>You are now an independent Princess House Consultant</h2>
        </div>
      </ng-container>
      <ng-container *ngSwitchDefault>
        <div class="col-12 col-md-12">
          <h2 i18n>You will be an independent Princess House Consultant soon.</h2>
        </div>
      </ng-container>
    </ng-container>

    <ng-container
      [ngSwitch]="congratulationType"
      *ngIf="submittedConsultantInfo$ | async as submittedConsultantInfo"
    >
      <ng-container *ngSwitchCase="CongratulationTypes.Normal">
        <section *ngIf="isMexEnv">
          <div class="row">
            <div class="col-2 col-md-1 pr-n3 mr-md-n1"
              ><img
                class="icon img-fluid"
                alt="Consultant"
                src="assets/images/icons/cons-icon-trnsp.png"
              />
            </div>
            <div class="col-10 col-md-11 pt-2 text-medium">
              <span i18n
                >Your Consultant ID Number is:
                <strong>{{ submittedConsultantInfo.consultantBeeNumber }}</strong></span
              >
            </div>
          </div>

          <div class="row">
            <div i18n class="col-12 col-md-12 mt-3 text-medium offset-1 pl-md-2 pl-5 pr-5">
              Use the Consultant ID number above as your username to access our Consultant's Corner
              website.</div
            >
          </div>
          <div class="ph-row">
            <div class="col-12 col-md-6 mt-3">
              <div class="py-3 d-flex mt-3 mb-3">
                <button
                  (click)="onLoginToConsultantsCornerClick()"
                  class="btn btn-primary pl-1 pr-4"
                  [ngClass]="{
                    'btn-block': (isMobile$ | async) === true,
                    'w-335': (isMobile$ | async) === false
                  }"
                  i18n
                >
                  Login to Consultant’s Corner
                </button>
              </div>
            </div>
          </div>
        </section>
      </ng-container>

      <ng-container *ngSwitchCase="CongratulationTypes.Cash">
        <section class="cash-voucher-box" *ngIf="voucherBarcodeUrls$ | async as urls">
          <div class="column-mobile">
            <span class="text-double-dot" i18n>Your Cash Voucher</span>
            <span class="value reset-margin-mobile" *ngIf="!!urls.length; else loading">
              <a class="pointer" (click)="openVoucherUrls(urls)" i18n> Download </a>
            </span>
            <ng-template #loading>
              <div class="spinner spinner-border spinner-border-sm" role="status">
                <span class="sr-only" i18n>Loading...</span>
              </div>
            </ng-template>
          </div>
        </section>
        <div i18n class="text-medium expiration-space">
          Your registration will be ready after you paid the voucher in any stores. The voucher
          <a [href]="">expires in {{ VoucherDeadline }} days</a>.
        </div>

        <section class="cash-consultant-box">
          <ng-container *ngTemplateOutlet="notIssuedYet"></ng-container>
        </section>
      </ng-container>

      <ng-container *ngSwitchCase="CongratulationTypes.BankTransfer">
        <section class="cash-consultant-box">
          <ng-container *ngTemplateOutlet="notIssuedYet"></ng-container>
        </section>
        <p i18n class="text-medium text-medium-mobile">
          This is the explanation of the new applications about Bank transfer payment and Consultant
          registration
        </p>
        <p i18n class="text-medium text-medium-mobile">
          Your registratrion will be ready after you complete your bank trasfer using your CLABE.
        </p>
      </ng-container>

      <ng-container *ngSwitchCase="CongratulationTypes.BackOfficeIssue">
        <section class="consultant-box">
          <ng-container *ngTemplateOutlet="notIssuedYet"></ng-container>
        </section>
        <ng-container *ngIf="(isMobile$ | async) === true">
          <!-- TODO: StartNowApp - set href below -->
          <p i18n class="text-medium text-medium-mobile">
            Our team will be in touch with you
            <a [href]="">in 72 hours using your previously entered contact information</a>.
          </p>
        </ng-container>
      </ng-container>
    </ng-container>
    <section
      *ngIf="
        isUsaEnv && congratulationType === CongratulationTypes.Normal && submittedConsultantInfo$
          | async as submittedConsultantInfo
      "
    >
      <ng-container>
        <div class="row">
          <div class="col-2 col-md-1 pr-n3 mr-md-n1"
            ><img
              class="icon img-fluid"
              alt="Consultant"
              src="assets/images/icons/cons-icon-trnsp.png"
            />
          </div>
          <div class="col-10 col-md-11 pt-2 text-medium">
            <span i18n
              >Your Consultant ID Number is:
              <strong>{{ submittedConsultantInfo.consultantBeeNumber }}</strong></span
            >
          </div>
        </div>

        <div class="row">
          <div i18n class="col-12 col-md-12 mt-3 text-medium">
            Use the Consultant ID number above as your username to access our Consultant's Corner
            website.</div
          >
        </div>
        <div class="ph-row">
          <div class="col-12 col-md-6 mt-3">
            <div class="py-3 d-flex mt-3 mb-3">
              <button
                (click)="onLoginToConsultantsCornerClick()"
                class="btn btn-primary pl-1 pr-4"
                [ngClass]="{
                  'btn-block': (isMobile$ | async) === true,
                  'w-335': (isMobile$ | async) === false
                }"
                i18n
              >
                Login to Consultant’s Corner
              </button>
            </div>
          </div>
        </div>
        <div class="row mt-3">
          <div i18n class="col-12 col-md-12 mt-2 mb-3 text-medium">
            Keep an eye out for a text message from 508.225.6004—it will include links to your
            training videos.</div
          >
        </div>
      </ng-container>
    </section>
    <div class="row">
      <div class="col-12 col-md-6">
        <app-recruiter-info-card [submittedConsultant]="submittedConsultantInfo$ | async">
        </app-recruiter-info-card>
      </div>
      <div class="col-12 col-md-6">
        <app-organizer-info-card [submittedConsultant]="submittedConsultantInfo$ | async">
        </app-organizer-info-card>
      </div>
    </div>
    <h3 i18n class="mt-5">Your Application Details</h3>
    <app-congratulation-summary></app-congratulation-summary>
  </div>

  <ng-template #notIssuedYet>
    <div>
      <span class="text-double-dot" i18n>Your Consultant ID Number is</span>
      <span class="value" i18n>Not issued yet</span>
    </div>

    <ng-container [ngSwitch]="congratulationType">
      <ng-container *ngSwitchCase="CongratulationTypes.Normal"> </ng-container>
      <ng-container *ngSwitchCase="CongratulationTypes.Cash">
        <div i18n class="text-medium">
          This is is the explanation of the new applications about Voucher payment and Consultant
          registration
        </div>
      </ng-container>
      <ng-container *ngSwitchCase="CongratulationTypes.BackOfficeIssue">
        <!-- TODO: StartNowApp - set href below -->
        <ng-container *ngIf="(isMobile$ | async) === false">
          <div i18n class="text-medium">
            Our team will be in touch with you
            <a [href]="">in 72 hours using your previously entered contact information</a>.
          </div>
        </ng-container>
      </ng-container>
    </ng-container>
  </ng-template>
</div>
